import { Route } from 'react-router';
import { ROUTES } from '../../../../core/router/routes';
import UsersAdd from '../../usersAdd/UsersAdd';
import UsersList from '../../usersList/UsersList';

const UsersRoutes = () => [
  <Route path={ROUTES.USERS.ADD} key={ROUTES.USERS.ADD} component={UsersAdd} />,
  <Route path={ROUTES.USERS.LIST} key={ROUTES.USERS.LIST} component={UsersList} />,
];

export default UsersRoutes;
